import { useEffect, useState } from 'react';
import { getContractBreakdown } from '../api';

/**
 * A project's contract breakdown (server/contractBreakdown.js) -- contract on file = SOV on the pay apps + freeform invoices +
 * not billed yet -- or null when it has no SOV to compare. For the SOV tab's contract check and the contract value
 * drop-downs (the job's top bar, the Job Cost tiles). refreshKey refetches it.
 */
export default function useContractBreakdown(projectId, refreshKey) {
  const [breakdown, setBreakdown] = useState(null);
  useEffect(() => {
    if (!projectId) { setBreakdown(null); return undefined; }
    let live = true;
    getContractBreakdown(projectId)
      .then((r) => { if (live) setBreakdown((r && r.breakdown) || null); })
      .catch(() => { if (live) setBreakdown(null); });
    return () => { live = false; };
  }, [projectId, refreshKey]);
  return breakdown;
}
